/* eslint-disable @typescript-eslint/no-unused-vars */
// TODO: Fix unused vars

import { useCallback, useEffect, useState } from 'react';
import { FILTER_NAMES } from '../../../../components/filters/hooks/filter-names.constants';
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { MassEditBlock } from '../mass-edit-sidebar/mass-edit-sidebar.component';
import { ExtendedCellProps } from './scenario-planner-details-table.component';

export const ScenarioPlannerInputCellComponent = ({
  onRunEdit,
  onClearCell,
  data,
  col,
  inputTypeOptions,
}: ExtendedCellProps) => {
  const [timeoutId, setTimeoutId] = useState<any>();
  const inputTypeField = `${col.idField}_INPUT_TYPE_ID`;
  const inputField = `${col.idField}_INPUT`;
  const fieldId = `${col.idField}`;
  const value = data[inputField] === null ? '' : data[inputField];
  const changeTypeValue =
    data[inputTypeField] === null ? 'perc' : data[inputTypeField];
  const [input, setInput] = useState<string>(value);
  const [disabled, setDisabled] = useState<boolean>(false);

  const [changed, setChanged] = useState(false);

  // Check if cell has a value to show clear button
  const hasValue = input !== '' && input !== null && input !== undefined;

  useEffect(() => {
    if (changed && onRunEdit) {
      const selectedValue: FilterSelectedValue = {
        id: FILTER_NAMES.PROD,
        values: [
          {
            label: data.name,
            value: data.id,
          },
        ],
      };
      const editBlock: MassEditBlock = {
        fieldId,
        inputType: changeTypeValue,
        value: input ? parseFloat(input) : undefined,
      };
      setDisabled(true);
      onRunEdit([editBlock], [selectedValue]).then(() => {
        setDisabled(false);
      });
    }
  }, [changeTypeValue, changed, data.id, data.name, fieldId, input, onRunEdit]);

  useEffect(() => {
    if (changed) {
      data[inputField] = input ? parseFloat(input) : undefined;
    }
  }, [changed, data, input, inputField]);

  // useEffect(() => {
  //     if (changed) {
  //         data[inputTypeField] = changeType
  //     }
  // }, [changed, data, changeType, inputTypeField])

  // useEffect(() => {
  //     if (changeType !== undefined && changeType !== changeTypeValue) {
  //         setTimeoutId(setTimeout(() => setChanged(true), 1000))
  //     }
  // }, [changeType, changeTypeValue])

  useEffect(() => {
    if (input !== undefined && input !== value) {
      setTimeoutId(setTimeout(() => setChanged(true), 1000));
    }
  }, [input, value]);

  useEffect(() => {
    return () => clearTimeout(timeoutId);
  }, [timeoutId]);

  // const handleChangeType = useCallback((value: string) => {
  //     setChangeType(value)
  //     if (input === '') {
  //         setInput('0')
  //     }
  // }, [input])

  // Handle clear button click
  const handleClear = useCallback(async () => {
    if (onClearCell && hasValue) {
      setDisabled(true);
      try {
        await onClearCell(data, col);
        setInput(''); // Update local state
        // Update the data object immediately
        data[inputField] = undefined;
      } catch (error) {
        // TODO: Handle error
      } finally {
        setDisabled(false);
      }
    }
  }, [onClearCell, data, col, hasValue, inputField]);

  return (
    <div className={`scenario-planner-input-cell ${col.id}`}>
      <div className="input-container">
        <input
          type="number"
          className={`form-control change-input ${input ? 'input-has-value' : ''}`}
          value={input}
          onChange={(event) => setInput(event.target.value)}
          placeholder="-"
          disabled={disabled}
        />
        {hasValue && (
          <button
            type="button"
            className="btn-clear-cell"
            onClick={handleClear}
            disabled={disabled}
            title="Clear cell value"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4V10H7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M23 20V14H17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>

      <div className={`change-type ${input ? 'select-has-value' : ''}`}>
        {inputTypeOptions?.find((i) => i.value === changeTypeValue)?.label}
      </div>
    </div>
  );
};
